export default __webpack_public_path__ + "static/media/wallpaper_bg0.90d95a60.png";